import React, { useState } from 'react'
import * as api from '../../services/api.js'
import AppSelect from '../../components/AppSelect.jsx'

const FEELINGS = [
  { id: 'calm', emoji: '🌿', label: 'Calm' },
  { id: 'good', emoji: '😊', label: 'Good' },
  { id: 'okay', emoji: '😐', label: 'Okay' },
  { id: 'hard', emoji: '😮‍💨', label: 'Hard going' },
]

export default function ReadingSessionModal({ book, onClose, onSaved }) {
  const today = new Date().toISOString().slice(0, 10)

  const [feeling,       setFeeling]       = useState('')
  const [date,          setDate]          = useState(today)
  const [progressValue, setProgressValue] = useState('')
  const [progressUnit,  setProgressUnit]  = useState(book?.type === 'audiobook' ? 'minutes' : 'pages')
  const [note,          setNote]          = useState('')
  const [saved,         setSaved]         = useState(false)

  async function handleSave() {
    if (!feeling) return
    const session = {
      book_id:        book.id,
      date,
      feeling,
      note:           note.trim() || null,
      progress_value: parseInt(progressValue) || null,
      progress_unit:  progressUnit || null,
    }
    await api.saveReadingSession(session)
    onSaved?.(session)
    setSaved(true)
    setTimeout(onClose, 1500)
  }

  return (
    <div
      className="session-modal-overlay"
      onClick={e => { if (e.target === e.currentTarget) onClose() }}
    >
      <div className="session-modal">
        {saved ? (
          <div style={{ textAlign: 'center', padding: '2.5rem 1rem' }}>
            <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🌿</div>
            <div style={{ fontSize: '0.9rem', color: 'var(--stone)', fontFamily: 'var(--font-serif)', fontStyle: 'italic' }}>
              Session logged.
            </div>
          </div>
        ) : (
          <>
            <div className="session-modal-header">
              <div>
                <div style={{ fontSize: '0.65rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'var(--stone)', marginBottom: 4 }}>
                  Log session
                </div>
                <div style={{ fontSize: '0.95rem', fontWeight: 700, fontFamily: 'var(--font-serif)', color: 'var(--ink)', lineHeight: 1.3 }}>
                  {book?.title}
                </div>
              </div>
              <button
                onClick={onClose}
                style={{ background: 'none', border: 'none', fontSize: '1rem', color: 'var(--stone)', cursor: 'pointer', flexShrink: 0 }}
                aria-label="Close"
              >
                ✕
              </button>
            </div>

            {/* Date */}
            <div style={{ marginBottom: '1rem' }}>
              <div className="session-label">Date</div>
              <input
                type="date"
                value={date}
                onChange={e => setDate(e.target.value)}
                className="session-input"
              />
            </div>

            {/* Feeling 2x2 */}
            <div style={{ marginBottom: '1rem' }}>
              <div className="session-label">
                How was it? <span style={{ color: '#DC2626' }}>*</span>
              </div>
              <div className="feeling-grid-2x2">
                {FEELINGS.map(f => (
                  <button
                    key={f.id}
                    className={`feeling-btn${feeling === f.id ? ' selected' : ''}`}
                    onClick={() => setFeeling(f.id)}
                  >
                    <span className="feeling-emoji">{f.emoji}</span>
                    <span className="feeling-label">{f.label}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* Progress */}
            <div style={{ marginBottom: '1rem' }}>
              <div className="session-label">
                Progress{' '}
                <span style={{ fontWeight: 400, textTransform: 'none', letterSpacing: 0 }}>
                  (optional)
                </span>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <input
                  type="number"
                  min="0"
                  placeholder="0"
                  value={progressValue}
                  onChange={e => setProgressValue(e.target.value)}
                  className="session-input"
                  style={{ flex: 1 }}
                />
                <AppSelect
                  value={progressUnit}
                  onChange={setProgressUnit}
                  options={[
                    { value: 'pages',    label: 'pages' },
                    { value: 'minutes',  label: 'minutes' },
                    { value: 'chapters', label: 'chapters' },
                    { value: 'percent',  label: 'percent' },
                  ]}
                  className="session-unit-select"
                />
              </div>
            </div>

            {/* Note */}
            <div style={{ marginBottom: '1.25rem' }}>
              <div className="session-label">
                Note{' '}
                <span style={{ fontWeight: 400, textTransform: 'none', letterSpacing: 0 }}>
                  (optional)
                </span>
              </div>
              <textarea
                value={note}
                onChange={e => setNote(e.target.value)}
                placeholder="Any thoughts from this session..."
                rows={2}
                className="session-textarea"
              />
            </div>

            {/* Actions */}
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="session-cancel-btn" onClick={onClose}>Cancel</button>
              <button
                className="session-save-btn"
                onClick={handleSave}
                disabled={!feeling}
                style={{ opacity: feeling ? 1 : 0.4 }}
              >
                Save
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
